<template lang="pug">
.adult-avatar
  delete-btn(v-if="adult" @delete="onRemove")
  //.delete(v-if="adult" @click="onRemove")
    img(src="~assets/btn-close.png")
    //.red
  .avatar
    template(v-if="adult")
      img(:src="adult.avatar" @click="onCheck")
    template(v-else)
      .placeholder(@click="$emit('click')")
        icon-plus

  .instruction {{adult? (adult.nickname ? adult.nickname : '家人') : $t('famPicker.addAdult')}}
  .warning(v-if="adult && adult.vspFaceStatus !== 1") 人脸未核验
</template>
<script>
import IconPlus from '@/components/res/IconPlus'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import DeleteBtn from '@/components/wedgits/DeleteBtn'
export default {
  name: 'AdultAvatar',
  components: { DeleteBtn, IconPlus },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['fam', 'user']),
    ...mapGetters('app', ['getAdultAdded']),
    adult() {
      return this.getAdultAdded.length > 0 ? this.getAdultAdded[0] : null
    },
  },
  methods: {
    ...mapActions('app', ['RemoveSubUser', 'GetUser']),
    ...mapMutations('app', ['setRouterBack', 'setPending']),
    onRemove() {
      let payload = {
        userId: this.user.id,
        subUserId: this.adult.id,
      }
      if (this.adult.type === 1) {
        payload = {
          subUserId: this.user.id,
          userId: this.adult.id,
        }
      }

      this.setPending(true)
      this.RemoveSubUser(payload).then((res) => {
        console.log(res)
        this.GetUser(this.user.id).then((res) => {
          this.setPending(false)
        })
      })
    },

    onCheck() {
      if (this.adult.vspFaceStatus !== 1) {
        this.$emit('verify', this.adult.id)
      }
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.adult-avatar
  width: 100%
  position: relative
  //.delete
    position: absolute
    width: pxToRem(45)
    height: pxToRem(45)
    //border-radius: pxToRem(15)
    //background-color: white
    top: pxToRem(5)
    right: pxToRem(5)
    line-height: 0
    img
      width: 100%
      object-fit: contain
    //+flex-center
    //.red
      width: 100%
      height: pxToRem(5)
      background-color: red
  .avatar
    width: pxToRem(180)
    height: pxToRem(180)
    box-shadow: pxToRem(-10) pxToRem(-10) pxToRem(17) 0 rgba(255,255,255,0.02), pxToRem(-19) pxToRem(-10) pxToRem(23) 0 rgba(252,252,252,0.74), pxToRem(-12) pxToRem(8) pxToRem(17) 0 rgba(252,252,252,0.35), pxToRem(2) pxToRem(13) pxToRem(43) 0 rgba(228,228,228,0.80)
    border-radius: pxToRem(90)
    border: white pxToRem(10) solid
    background: #ffffff
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden
    img
      width: 100%
    .placeholder
      width: pxToRem(36)
      height: pxToRem(36)
      line-height: 0
  .instruction
    font-size: pxToRem(30)
    text-align: center
    margin-top: pxToRem(20)
  .warning
    font-size: pxToRem(30)
    text-align: center
    margin-top: pxToRem(-5)
    color: #e15125
</style>
